import { Component, ChangeDetectionStrategy } from "@angular/core";

@Component({
    selector: "rask-virkesorder-viol3-preview",
    templateUrl: "./virkesorder-viol3-preview.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ["./virkesorder-viol3-preview.component.scss"]
})
export class VirkesorderViol3PreviewComponent {

}
